import React, { useEffect } from 'react';

export const flyCookie = (src, fromEl, toEl, dur = 800) => new Promise((res) => {
  if (!src || !fromEl || !toEl) { res(); return; }
  const a = fromEl.getBoundingClientRect();
  const b = toEl.getBoundingClientRect();
  const size = Math.min(a.width || 84, 84);
  const el = document.createElement('img');
  el.src = src;
  el.className = 'bx-fly';
  Object.assign(el.style, { left: `${a.left + a.width / 2 - size / 2}px`, top: `${a.top + a.height / 2 - size / 2}px`, width: `${size}px`, height: `${size}px` });
  document.body.appendChild(el);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2);
  const dy = b.top + b.height / 2 - (a.top + a.height / 2);
  const sc = Math.max(0.4, (b.width * 0.82) / size) || 0.75;
  const anim = el.animate([
    { transform: 'translate(0,0) rotate(0deg) scale(1)', offset: 0 },
    { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 90}px) rotate(200deg) scale(${(1 + sc) / 2})`, offset: 0.5 },
    { transform: `translate(${dx}px, ${dy - 16}px) rotate(352deg) scale(${sc * 1.12})`, offset: 0.86 },
    { transform: `translate(${dx}px, ${dy}px) rotate(360deg) scale(${sc})`, offset: 1 },
  ], { duration: dur, easing: 'cubic-bezier(.3,.7,.3,1)' });
  let done = false;
  const fin = () => { if (done) return; done = true; el.remove(); res(); };
  anim.onfinish = fin;
  setTimeout(fin, dur + 250);
});

export const BoiteDuo = ({ n, duo, picks, imgs, hide, msg, shakeTick, boxRef, slotRefs, onRemove, combo, comboDone, comboBusy, onCombo }) => {
  const pleine = picks.length >= n;
  const reste = n - picks.length;
  useEffect(() => {
    if (!shakeTick || !boxRef.current) return undefined;
    const el = boxRef.current;
    el.classList.add('bx-shake');
    const t = setTimeout(() => el.classList.remove('bx-shake'), 520);
    return () => clearTimeout(t);
  }, [shakeTick, boxRef]);
  const comboNoms = combo ? Object.entries(combo.cookies.reduce((m, c) => ({ ...m, [c]: (m[c] || 0) + 1 }), {})).map(([c, q]) => (q > 1 ? `${c} ×${q}` : c)) : [];
  return (
    <div className="bx-wrap" data-testid={duo ? 'borne-boite-duo' : 'borne-boite-box4'}>
      <div className="bx-titre">Ta boîte</div>
      <div ref={boxRef} className={`bx-box${n === 4 ? ' g4' : ''}${pleine ? ' full' : ''}`} data-testid="borne-boite">
        {Array.from({ length: n }, (_, i) => {
          const o = picks[i];
          return (
            <div key={i} className="bx-place">
              {o ? (
                <button className={`bx-slot plein${hide[i] ? ' cache' : ''}`} ref={(el) => { slotRefs.current[i] = el; }}
                  onClick={() => onRemove(i)} data-testid={`borne-boite-slot-${i + 1}`}>
                  {imgs?.[o] ? <img src={imgs[o]} alt={o} /> : <i>🍪</i>}
                </button>
              ) : (
                <div className="bx-slot vide" ref={(el) => { slotRefs.current[i] = el; }} data-testid={`borne-boite-slot-${i + 1}`}>
                  <span className="fredoka">{i + 1}</span>
                </div>
              )}
              {duo && <small className="bx-nom">{o || ''}</small>}
            </div>
          );
        })}
      </div>
      <div className="bx-stat" data-testid="borne-boite-statut">
        {msg ? <b className="alerte">{msg}</b> : pleine ? (
          <><b className="ok">✓ {duo ? 'Ton duo est prêt' : 'Ta box est prête'}</b><small>Touche un cookie pour le changer</small></>
        ) : picks.length === 0 ? (
          <><b>Choisis {n} cookies</b>{combo && <small>ou prends {duo ? 'le duo le plus commandé' : 'la box la plus commandée'}</small>}</>
        ) : (
          <b>Encore {reste} cookie{reste > 1 ? 's' : ''}</b>
        )}
      </div>
      {combo && (
        <div className="bx-combo" data-testid="borne-combo-card">
          <div className="bx-combo-tit">★ {duo ? 'Le duo le plus commandé' : 'La box de 4 la plus commandée'}</div>
          <div className="bx-combo-noms">{comboNoms.join(' + ')}</div>
          <button className={`bx-go${comboDone ? ' ok' : ''}`} disabled={comboBusy} onClick={onCombo} data-testid="borne-combo-prendre">
            {comboDone ? '✓ Dans ta boîte' : duo ? 'Je prends ce duo' : 'Je prends cette box'}
          </button>
        </div>
      )}
    </div>
  );
};
